import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AllCategory = () => {
  const [allCategory, setAllCategory] = useState("");
  const navigate = useNavigate();

  const handleAddNewCategory = () => {
    navigate("/add-category");
  };

  const handleViewAllCategory = () => {
    navigate("/all-category");
  };

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  // CLASSES DATA GET FUN AXIOS --
  const getCategory = () => {
    axios
      .get(`${API_BASE_URL}/category`)
      .then((resp) => {
        console.log(resp);
        const { data } = resp.data;
        setAllCategory(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getCategory();
  }, []);

  // API DELETE FUN
  let handleSchoolClassDlt = async (id) => {
    let dltOrNot = window.confirm("Do you want to delete");
    if (dltOrNot) {
      axios
        .delete(`${API_BASE_URL}/admin/category/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((resp) => {
          console.log(resp);
          getCategory();
        });
    }
  };

  const handleEdit = (id) => {
    navigate(`/edit-category/${id}`);
  };

  return (
    <>
      <div id="classes-inner-wrapper">
        <div className="classes-header-div">
          <h5>Category</h5>
          <div className="classes-header-btns">
            <button className="add-class-btn" onClick={handleAddNewCategory}>
              + Add New Category
            </button>
            <button className="all-classes-btn" onClick={handleViewAllCategory}>
              All Category
            </button>
          </div>
        </div>

        <div className="classes-table-container">
          <h5>All Category</h5>
          <table className="classes-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Category</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {allCategory &&
                [...allCategory].reverse().map((item, idx) => (
                  <tr key={item?._id}>
                    <td>{idx + 1}</td>
                    <td>{item?.category}</td>

                    <td className="table-action-icons">
                      <i
                        className="fa-solid fa-file-pen"
                        onClick={() => handleEdit(item?._id)}
                      ></i>
                      <i
                        className="fa-solid fa-trash-can"
                        onClick={() => handleSchoolClassDlt(item?._id)}
                      ></i>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AllCategory;
